import lotusDarkLogoUrl from './LotusDarkLogo.svg';
import lotusMorphUrl from './LotusMorph.png';
import blurflowerUrl from './BlurFlower.png';
import iPhoneExperianMockUrl from './iPhoneExperianMock.png';

export const lotusDarkLogo = lotusDarkLogoUrl;
export const lotusMorph = lotusMorphUrl;
export const blurflower = blurflowerUrl;
export const iPhoneExperianMock = iPhoneExperianMockUrl;
